import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Heading, Button, TextInput, Anchor, Image, Text } from 'grommet';
import { CircleQuestion } from 'grommet-icons';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Dashboard from 'assets/dashboard.png';
import { useToast } from 'granite-admin/core/components/Toast';
import SplitLayout from 'granite-admin/core/components/SplitLayout';
import FormField from 'granite-admin/core/components/FormField';
import { ssoLogin } from 'granite-admin/accounts/controllers/user';
import Tooltip from 'granite-admin/core/components/Tooltip';
const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
const msg = `Sign in to your ${projectName} Account`;
const validationSchema = Yup.object().shape({
  email: Yup.string().min(2, 'Email too short').max(50, 'Email too long').email('Please enter valid email').required('Email is required')
});
const Sso = () => {
  const {
    errorToast
  } = useToast();
  const onSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      const {
        data
      } = await ssoLogin(values.email);
      window.location.href = data.url;
    } catch (e) {
      errorToast(e.errors?.title || 'SSO configuration not found !!!');
    }
    setSubmitting(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SplitLayout, {
    mainContent: /*#__PURE__*/React.createElement(Box, {
      width: "large",
      flex: "grow"
    }, /*#__PURE__*/React.createElement(Heading, {
      level: 3
    }, "SSO Sign In "), /*#__PURE__*/React.createElement(Heading, {
      level: 5,
      size: "large",
      color: "dark-2"
    }, msg), /*#__PURE__*/React.createElement(Formik, {
      validationSchema: validationSchema,
      onSubmit: onSubmit,
      initialValues: {
        email: ''
      }
    }, ({
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting
    }) => /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit,
      autoComplete: "off"
    }, /*#__PURE__*/React.createElement(FormField, {
      name: "email",
      label: "Email Address or Username*",
      error: touched.email && errors.email
    }, /*#__PURE__*/React.createElement(TextInput, {
      name: "email",
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.email
    })), /*#__PURE__*/React.createElement(Box, {
      justify: "between",
      direction: "row",
      margin: {
        top: 'xsmall'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      alignSelf: "start",
      label: "Next",
      disabled: isSubmitting,
      primary: true,
      color: "secondary"
    }), /*#__PURE__*/React.createElement(Link, {
      to: "/login"
    }, /*#__PURE__*/React.createElement(Anchor, {
      as: "span",
      color: "secondary",
      label: "Standard Sign in",
      style: {
        fontSize: '12px'
      }
    }), /*#__PURE__*/React.createElement(Tooltip, {
      border: {
        color: 'lightgray',
        size: 'xsmall'
      },
      background: "white",
      content: /*#__PURE__*/React.createElement(Text, null, "Use standard Sign In for login", /*#__PURE__*/React.createElement("br", null), " using username and password.")
    }, /*#__PURE__*/React.createElement(CircleQuestion, {
      size: "15px",
      style: {
        marginLeft: '6px',
        verticalAlign: 'middle'
      }
    }))))))),
    sideContent: /*#__PURE__*/React.createElement(Box, {
      fill: true
    }, /*#__PURE__*/React.createElement(Image, {
      src: Dashboard,
      fit: "cover"
    })),
    bannerPadding: "none",
    mainProps: {
      style: {
        marginTop: '3%'
      }
    }
  }));
};
export default Sso;